import { styled } from '@creditas-ui/system';
import { selectTheme } from '@creditas-ui/utilities';

export const Nav = styled.nav`
  position: relative;
  width: 100%;
`;

export const Line = styled.div`
  display: block;
  position: absolute;
  width: 4px;
  height: 60px;
  background-color: ${selectTheme('colors.primary.60')};
  left: -22px;
  top: 0;
  border-radius: 0 4px 4px 0;
  transition: 0.5s;
`;
